import React from "react";
import { makeStyles, Dropdown, Option } from "@fluentui/react-components";
import { DimensionType, DIMENSION_LABELS } from "../types";

const useStyles = makeStyles({
  dropdown: {
    minWidth: "150px",
  },
});

interface DimensionSelectorProps {
  value: DimensionType;
  onChange: (dimension: DimensionType) => void;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
}

const DIMENSIONS: DimensionType[] = [
  "brand",
  "category",
  "country",
  "customer",
  "customerGroup",
  "department",
  "group",
  "item",
  "month",
  "productionUnit",
  "salesPerson",
  "sector",
  "sectorToplevel",
  "vendor",
];

export const DimensionSelector: React.FC<DimensionSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  size = "medium",
}) => {
  const styles = useStyles();

  return (
    <Dropdown
      id="dimension-select"
      value={DIMENSION_LABELS[value]}
      selectedOptions={[value]}
      onOptionSelect={(_, data) => {
        if (data.optionValue) {
          onChange(data.optionValue as DimensionType);
        }
      }}
      disabled={disabled}
      className={styles.dropdown}
      size={size}
    >
      {DIMENSIONS.map((dim) => (
        <Option key={dim} value={dim}>
          {DIMENSION_LABELS[dim]}
        </Option>
      ))}
    </Dropdown>
  );
};
